const moveWishlistButtons = () => {
  document.querySelectorAll('form.shopify-product-form').forEach((productForm) => {
    const buttonRow = productForm.querySelector('.product-form-buttons');
    const wishlistWrappers = [...productForm.querySelectorAll('.Vtl-WishlistButtonWrapper')];

    if (!buttonRow || wishlistWrappers.length === 0) return;

    const wishlistWrapper = wishlistWrappers[0];
    if (!buttonRow.contains(wishlistWrapper)) buttonRow.append(wishlistWrapper);

    wishlistWrappers.slice(1).forEach((duplicate) => duplicate.remove());
  });

  document.querySelectorAll('.Vtl-WishlistButtonWrapper').forEach((wishlistWrapper) => {
    const productForm = wishlistWrapper.closest('form.shopify-product-form');
    const buttonRow = productForm?.querySelector('.product-form-buttons');

    if (buttonRow && !buttonRow.contains(wishlistWrapper)) {
      buttonRow.append(wishlistWrapper);
    }
  });
};

moveWishlistButtons();
requestAnimationFrame(moveWishlistButtons);
setTimeout(moveWishlistButtons, 500);

const wishlistObserver = new MutationObserver(moveWishlistButtons);
wishlistObserver.observe(document.body, { childList: true, subtree: true });
